import { createSelector } from 'reselect'
const modelsSelector = state => state.models
const allModelsSelector = state => state.allmodels

export const selectorOtherModels = createSelector(
  modelsSelector,
  allModelsSelector,
  (models, allmodels) => allmodels.filter(f => !models.includes(f))
)
